import { CommonModule } from '@angular/common';
import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PermittedAccessThs } from 'src/app/model/permission';
import { Thermo, ThermoBnB, ThermoQnE } from 'src/app/model/thermo';
import { StandardPageLayout } from '../../stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-thermo-realtime-temp-info',
	standalone: true,
	imports: [CommonModule, TranslateModule],
	templateUrl: './thermo-realtime-temp-info.component.html'
})
export class ThermoRealtimeTempInfoComponent implements OnInit, OnChanges {
	@Input() thermoInput: Thermo | PermittedAccessThs;
	@Input() camelCaseFormat: boolean | undefined;

	thermo: Thermo = new Thermo();

	screenWidth: number;

	ngOnInit(): void {
		this.mapCamelCaseFormat();
		this.onResize();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['thermoInput'] || changes['camelCaseFormat']) {
			this.mapCamelCaseFormat();
		}
	}

	mapCamelCaseFormat(): void {
		if (!this.thermoInput) {
			this.thermo = new Thermo();
			return;
		}

		if (this.camelCaseFormat) {
			const source = this.thermoInput as PermittedAccessThs;
			const mapped = new Thermo();
			mapped.keycode = source.Keycode;
			mapped.manual_temp = source.ManualTemp;
			mapped.temp_loc = source.TempLoc;
			mapped.hum_loc = source.HumLoc;
			mapped.mode = source.Mode;
			mapped.current_season = source.CurrentSeason;
			mapped.relay_status = source.RelayStatus;
			mapped.on_line = source.Online;

			if (source.Bb) {
				mapped.bb = new ThermoBnB();
				mapped.bb.enable = source.Bb.Enable;
				mapped.bb.delta_temp_n = source.Bb.DeltaTempN;
				mapped.bb.delta_temp_p = source.Bb.DeltaTempP;
				mapped.bb.temp = source.Bb.Temp;
			}

			if (source.Qe) {
				mapped.qe = new ThermoQnE();
				mapped.qe.enable = source.Qe.Enable;
				mapped.qe.stdby_temp = source.Qe.StdbyTemp;
				mapped.qe.courtesy_time = source.Qe.CourtesyTime;
			}

			this.thermo = mapped;
		} else {
			this.thermo = this.thermoInput as Thermo;
		}
	}

	getBorderColor(): string {
		const thermo = this.thermo;
		if (!thermo || !thermo?.relay_status || thermo?.relay_status !== 1 || !thermo?.current_season) {
			return '';
		}
		const season = thermo?.current_season;
		const borderStyle = ' border-round border-2 ';
		switch (season) {
			case 'summer':
				return borderStyle + 'border-primary';
			case 'winter':
				return borderStyle + 'border-red-600';
			default:
				return '';
		}
	}

	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}
